 // array of options for Type drop-down in Filter component
  const allTypes = [
    {
      value: "fire",
      label: "Fire",
    },
    {
      value: "grass",
      label: "Grass",
    },
    {
      value: "water",
      label: "Water",
    },
    {
      value: "normal",
      label: "Normal",
    },
    {
      value: "dark",
      label: "Dark",
    },
    {
      value: "electric",
      label: "Electric",
    },
    {
      value: "ice",
      label: "Ice",
    },
    {
      value: "psychic",
      label: "Psychic",
    },
    {
      value: "ground",
      label: "Ground",
    },
    {
      value: "rock",
      label: "Rock",
    },
    {
      value: "bug",
      label: "Bug",
    },
    {
      value: "fighting",
      label: "Fighting",
    },
    {
      value: "poison",
      label: "Poison",
    },
    {
      value: "ghost",
      label: "Ghost",
    },
    {
      value: "fairy",
      label: "Fairy",
    },
    {
      value: "dragon",
      label: "Dragon",
    },
    {
      value: "steel",
      label: "Steel",
    },
    {
      value: "flying",
      label: "Flying",
    },
  ];

  export default allTypes;